export default "__VITE_ASSET__nrNHCtJx__"